import IngredientRow from "./IngredientRow";
import { useTranslation } from 'react-i18next';


function IngredientTable({ ingredients, updateOrder, updateEcological, ingredientsLength }) {
  const { t } = useTranslation();

  const moveUp = (id) => {
    const index = ingredients.findIndex((item) => item.id === id);
    if (index > 0) {
      const updatedIngredients = [...ingredients];
      [updatedIngredients[index], updatedIngredients[index - 1]] = [
        updatedIngredients[index - 1],
        updatedIngredients[index],
      ];
      updateOrder(updatedIngredients);
    }
  };

  const moveDown = (id) => {
    const index = ingredients.findIndex((item) => item.id === id);
    if (index < ingredients.length - 1) {
      const updatedIngredients = [...ingredients];
      [updatedIngredients[index], updatedIngredients[index + 1]] = [
        updatedIngredients[index + 1],
        updatedIngredients[index],
      ];
      updateOrder(updatedIngredients);
    }
  };

  return (
    <div className="table-container-1">
      <table className="product-table w98pe">
        <thead>
          <tr>
          <th>{t("ingredientTable.headers.ingredient")}</th>
            <th></th>
            <th>{t("ingredientTable.headers.ecologicalAgriculture")}</th>
            <th>{t("ingredientTable.headers.type")}</th>
          </tr>
        </thead>
        <tbody>
          {ingredients.map((ingredient, index) => (
            <IngredientRow
              key={ingredient.id}
              ingredient={ingredient}
              index={index}
              moveUp={moveUp}
              moveDown={moveDown}
              updateEcological={updateEcological}
              ingredientsLength={ingredientsLength}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default IngredientTable;